/**
 * Handles scroll-to links functionality.
 */

import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin( ScrollToPlugin );

( function( $ ) {

	let viewportOffset = 0;
    const scrollToOffset = 48;

    // Utils

    function setViewportOffset() {

        const header = $( 'header.et-l--header' )

		if ( ! header.length ) return
        
        viewportOffset = header.get( 0 ).getBoundingClientRect().bottom
    }

    // Initialize

    $( window ).load( function() {

		// We have to monkey patch Divi's sillyness

		if ( window.et_pb_smooth_scroll ) {

			window.et_pb_smooth_scroll = function( target, ...silliness ) {

				if ( target[0].id ) {
					history.replaceState( {}, '', `#${target[0].id}` )
					gsap.to( window, { scrollTo: { y: `#${target[0].id}`, offsetY: viewportOffset + scrollToOffset } } )
				}
			}

			setViewportOffset();
			$( window ).on( 'resize', setViewportOffset )
		}   

    } );
    
} )( jQuery );